import 'globals';

window.cookieconsent.initialise({
    showLink: false,
    palette: {
        popup: {
            text: '#212529',
            background: '#fff'
        }
    },
    layout: 'rvHandorf',
    layouts: {
        rvHandorf: '<div class="container"><div class="row align-items-center"><div class="col-md my-3">{{message}}{{link}}</div><div class="col-md-auto my-3">{{compliance}}</div></div></div>'
    },
    elements: {
        dismiss: '<a aria-label="dismiss cookie message" tabindex="0" class="btn btn-primary pmd-ripple-effect m-0 cc-btn cc-dismiss"><i class="ai ai-accept"></i>{{dismiss}}</a>',
        message: '<div id="cookieconsent:desc">{{message}} <a href="{{href}}">{{linkText}}</a></div>',
    },
    content: {
        dismiss: _AVENCY_BASE_translations.rvHandorf.cookieHint.dismiss,
        linkText: _AVENCY_BASE_translations.rvHandorf.cookieHint.link,
        message: _AVENCY_BASE_translations.rvHandorf.cookieHint.message,
        href: _AVENCY_BASE_pages.privacyPolicy
    },
    cookie: window.location.hostname
});